export { ToolReturnsComponent } from './tool-returns.component';
export { ToolReturnsTableComponent } from './components/tool-returns-table/tool-returns-table.component';
export { ToolReturnsInspectComponent } from './components/tool-returns-inspect/tool-returns-inspect.component';
